export interface ExploreVideo {
  src: string
  titleEn: string
  titleEs: string
  borderColor: string
  delay: number
}

export const exploreVideos: ExploreVideo[] = [
  {
    src: 'https://www.youtube.com/embed/QWTirhWSO24',
    titleEn: 'Explore Honduras — Featured Video',
    titleEs: 'Explora Honduras — Video Destacado',
    borderColor: 'border-haa-blue',
    delay: 0.15,
  },
  {
    src: 'https://www.youtube.com/embed/KUghuMX8WkQ',
    titleEn: 'Explore Honduras — Video 2',
    titleEs: 'Explora Honduras — Video 2',
    borderColor: 'border-haa-blue',
    delay: 0.2,
  },
  {
    src: 'https://www.youtube.com/embed/qMzfzAnQOjc',
    titleEn: 'Explore Honduras — Featured Video',
    titleEs: 'Explora Honduras — Video Destacado',
    borderColor: 'border-red-500',
    delay: 0.25,
  },
]
